<template>
  <div
    class="dx-swatch-additional side-navigation-menu"
    @click="forwardClick"
  >
    <slot />
    <div class="menu-container">
      <dx-tree-view
        :key="sideMenuStore.rerenderKey"
        ref="treeViewRef"
        :items="nav"
        key-expr="path"
        selection-mode="single"
        :focus-state-enabled="false"
        expand-event="click"
        @item-click="handleItemClick"
        width="100%"
      >
      <template #item="item" >
        <i :class="`dx-icon dx-icon-${item.data.icon}`" v-if="item.data.icon"></i>
        <span v-if="!item.data.text?.includes('Уведомления')">{{ item.data.text }}
        </span>
        <span v-else :class="{ 'dx-treeview__notify': sideMenuStore.trigger }" >
          {{ item.data.text }}
        </span>
      </template>
      </dx-tree-view>
    </div>
  </div>
</template>

<script>
import DxTreeView from "devextreme-vue/ui/tree-view";
import { onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router'; 
import { useSideMenuStore } from '@/stores/side-menu';
import { useSignalR } from "@dreamonkey/vue-signalr";
import { connection } from "@/hub-connection";


export default {
  props: {
    compactMode: Boolean
  },
  setup(props, context) {
    const route = useRoute();
    const router = useRouter();
 
    const sideMenuStore = useSideMenuStore();
    sideMenuStore.setItems();
    const getCount = async() => { await sideMenuStore.getCountNotify() };
    getCount();
    sideMenuStore.updateItemProperties();
    const signalr = useSignalR();
    const nav = ref();
    nav.value = sideMenuStore.nav

    onMounted(async () => { 
      updateSelection();
      if (props.compactMode) {
        treeViewRef.value.instance.collapseAll();
      }
      
      signalr.on("UpdateManagerNotificationCounter", (newCounter) => {
        sideMenuStore.setUnReadCount(newCounter);
        nav.value = sideMenuStore.nav;
      })
      connection.onreconnected(async () => {
        await sideMenuStore.getCountNotify();
      });
    });
    const treeViewRef = ref(null);

    function forwardClick (...args) {
      context.emit("click", args);
    }

    function handleItemClick(e) {
      if (!e.itemData.path || props.compactMode) {
        return;
      }
      router.push(e.itemData.path);

      const pointerEvent = e.event;
      pointerEvent.stopPropagation();
    }

    function updateSelection () {
      if (!treeViewRef.value || !treeViewRef.value.instance) {
        return;
      }

      treeViewRef.value.instance.selectItem(route.path);
      treeViewRef.value.instance.expandItem(route.path);
    }
    

    watch(
      () => route.path,
      () => {
        updateSelection();
      }
    );
    
    watch(
      () => props.compactMode,
      () => {
        if (props.compactMode) {
          treeViewRef.value.instance.collapseAll();
        } else {
          updateSelection();
        }
      }
    );

    return {
      treeViewRef,
      forwardClick,
      handleItemClick,
      updateSelection,
      sideMenuStore,
      getCount,
      nav
    };
  },
  components: {
    DxTreeView
  }
};
</script>

<style lang="scss">
@import "../dx-styles.scss";
@import "../themes/generated/variables.additional.scss";

.side-navigation-menu {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  width: 300px !important;

  .menu-container {
    min-height: 100%;
    display: flex;
    flex: 1;

    .dx-treeview {
      // ## Long text positioning
      white-space: nowrap;
      // ##

      // ## Icon width customization
      .dx-treeview-item {
        padding-left: 0;
        padding-right: 0;

        .dx-icon {
          width: $side-panel-min-width !important;
          margin: 0 !important;
        }
      }
      // ##

      // ## Arrow customization
      .dx-treeview-node {
        padding: 0 0 !important;
      }

      .dx-treeview-toggle-item-visibility {
        right: 10px;
        left: auto;
      }

      .dx-rtl .dx-treeview-toggle-item-visibility {
        left: 10px;
        right: auto;
      }
      // ##

      // ## Item levels customization
      .dx-treeview-node {
        &[aria-level="1"] {
          font-weight: bold;
          border-bottom: 1px solid $base-border-color;
        }

        &[aria-level="2"] .dx-treeview-item-content {
          font-weight: normal;
          padding: 0 $side-panel-min-width;
        }
      }
      // ##
    }

    // ## Selected & Focuced items customization
    .dx-treeview {
      .dx-treeview-node-container {
        .dx-treeview-node {
          &.dx-state-selected:not(.dx-state-focused) > .dx-treeview-item {
            background: transparent;
          }

          &.dx-state-selected > .dx-treeview-item * {
            color: $base-accent;
          }

          &:not(.dx-state-focused) > .dx-treeview-item.dx-state-hover {
            background-color: lighten($base-bg, 4);
          }
        }
      }
    }

    .dx-theme-generic .dx-treeview {
      .dx-treeview-node-container
        .dx-treeview-node.dx-state-selected.dx-state-focused
        > .dx-treeview-item
        * {
        color: inherit;
      }
    }
    // ##
  }

  .dx-treeview__notify {
    color: rgb(214,15,15) !important
  }
}
</style>
